
import indoor from "../../assets/indoor.png"
import yard from "../../assets/yard.png"
import assessment from "../../assets/assessment.png"
import electricity from "../../assets/electricity.png"

const data = [
  {
    id: 1,
    icon: indoor, 
    title: 'Indoor Renovation',
    desc1:"Hard wood Flooring",
    desc2:"Painting",
    desc3:"Plastering",
    desc4:"Bathroom and Kitchen",
    link:"#portfolio"
  },
  {
    id: 2,
    icon: yard,
    title: 'Yard Renovation',
    desc1:"Doors steps",
    desc2:"Deck & Patio",
    desc3:"Land Scaping",
    desc4:"Snow removal & Racking leaves",
    link:"#portfolio"
     },
  {
    id: 3,
    icon: electricity,
    title: 'Electricity',
    desc1:"Heater replacement",
    desc2:"Hood & Ceiling Fan",
    desc3:"Light Fixtures",
    desc4:"And more . . .",
    link:"#portfolio"
     },
  {
    id: 4,
    icon: assessment,
    title: 'Assessment',
    desc1:"Manpower",
    desc2:"Materials",
    desc3:"Cost estimation in 24 to 48H",
    desc4:"And more . . .",
    link:"#portfolio"
     },
]

export default data
